import { global_hooks } from 'src/globals';
import { get_cookie } from 'js/utils';

global_hooks.on('before_init', init);

function init() {
	const cta = document.querySelector('.footer_sticky_cta');
	if (!cta) return;

	if (ff.is_elementor_edit) {
		import('./footer_sticky_cta.scss');
		return;
	}

	if (get_cookie('footer_sticky_cta_close')) {
		cta.remove();
		return;
	}

	import('./footer_sticky_cta.scss');
	import('./footer_sticky_cta');
}
